import { render, staticRenderFns } from "./OpenLinkIcon.vue?vue&type=template&id=7b0d06f2&"
import script from "./OpenLinkIcon.vue?vue&type=script&lang=js&"
export * from "./OpenLinkIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports